/** @flow */

import { object, boolean } from "yup";

const MUST_ACCEPT_TERMS_AND_CONDITIONS = "Must accept terms and conditions";

export const DisclaimersSchema = object().shape({
  attestation_given: boolean().oneOf([true], MUST_ACCEPT_TERMS_AND_CONDITIONS),
  disclosures_approved: boolean().oneOf(
    [true],
    MUST_ACCEPT_TERMS_AND_CONDITIONS
  ),
  venmo_terms_accepted: boolean().oneOf(
    [true],
    MUST_ACCEPT_TERMS_AND_CONDITIONS
  )
});
